import { token } from "@atlaskit/tokens";
import styled from "styled-components";

export const AppUnlicensedMessageContainer = styled.div`
  position: absolute;
  top: 10px;
  right: 20px;
  transition: max-width 200ms linear;
  overflow: hidden;
  align-items: center;
`;

export const Divider = styled.div`
  height: 1px;
  opacity: 0.5;
  background: rgba(9, 30, 66, 0.14);
  margin-top: 20px;
  margin-bottom: 20px;
`;

export const RoundedAvatar24 = styled.img`
  width: 24px;
  height: 24px;
  border-radius: 6px;
`;

export const Title = styled.div`
  font-weight: 700;
  font-size: 32px;
  line-height: 38px;
  color: #fff;
`;

export const SpinnerContainer = styled.div`
  display: flex;
  place-content: center;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

export const ThinSpinnerContainer = styled(SpinnerContainer)`
  display: flex;
  place-content: center;
  margin: 15px 0;
  flex-direction: column;
  align-items: center;
  width: 100%;
  min-height: 100px;
`;

export const IconPickerSpinnerContainer = styled(SpinnerContainer)`
  min-height: unset;
  height: 24px;
  margin: 0;
  width: 24px;
`;

export const FieldsTableWrapper = styled.div`
  overflow: hidden auto;
  max-height: calc(100vh - 465px);
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

export const NoResultsText = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  color: #172b4d;
  display: grid;
  place-content: center;
  margin: 15px 0px;
`;

export const IconWrapper = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  column-gap: 8px;
`;

export const IconHoverWrapper = styled(IconWrapper)`
  border-radius: 3px;
  background: transparent;
  transition: all 400ms;

  &:hover {
    background: #f4f5f7;
  }
`;

export const MoreIconHoverWrapper = styled(IconHoverWrapper)`
  padding: 6px 8px;
  &:hover {
    padding: 6px 18px;
  }
`;

export const LightModePreview = styled.div.attrs({
  className: "light-mode-preview ",
})``;

export const Text = styled.p`
  all: unset;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: ${({ clr }) => clr};
`;

export const ShopTitle = styled.div`
  font-weight: 500;
  line-height: 20px;
  font-size: 20px;
  color: #172b4d;
`;

export const FieldLabel = styled.div`
  color: ${token("color.text.subtle")};
  font-size: 12px;
  font-weight: 590;
  line-height: 16px;
`;
